import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { removeStringFromMPPT } from "../../../../store/slices/pva_testReport.slices";
import StringInfo from "./stringInfo";

const StringAccordion = ({ str, inverterIndex, mpptIndex, stringIndex }) => {
  const dispatch = useDispatch();

  const handleDelete = (e) => {
    e.stopPropagation(); // prevent collapsing accordion on click
    dispatch(removeStringFromMPPT({ inverterIndex, mpptIndex, stringIndex }));
  };

  return (
    <Accordion>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        {/* 🔹 Expandable Header */}
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <Typography sx={{ flexGrow: 1, fontWeight: 500 }}>
              {str.id}
            </Typography>
          </Box>
        </AccordionSummary>

        {/* 🗑️ Delete Button (outside of AccordionSummary to avoid nested button issue) */}
        <IconButton
          size="small"
          color="error"
          onClick={handleDelete}
          sx={{ ml: 1 }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>

      <AccordionDetails>
        {/* Future: Editable fields for string sections */}
        <Box variant="body2" color="text.secondary">
          <StringInfo
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          />
          {/* <StringArr
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
          {/* <StringOCPD
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
          {/* <StringWiring
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
          {/* <StringTest
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
          {/* <StringPolarity
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
          {/* <StringIsolator
            inverterIndex={inverterIndex}
            mpptIndex={mpptIndex}
            stringIndex={stringIndex}
            stringData={str}
          /> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default StringAccordion;
